import { jsx as h } from "react/jsx-runtime";
import { BadRequest as E } from "@systemeio/util";
import P from "../../../ui-kit/theme-button.mjs";
import { useStripe as T, useElements as j } from "../../../node_modules/@stripe/react-stripe-js/dist/react-stripe.esm.mjs";
import { useStore as q } from "../../../store/index.mjs";
import { useStripeApi as x } from "../api/stripe-api.mjs";
import { twJoin as D } from "tailwind-merge";
import { IntentTypeEnum as O } from "../enum/intent-type-enum.mjs";
function G({
  isFetching: a,
  buttonTitle: c,
  buttonDisabled: f,
  setErrors: l,
  setIsFetching: o,
  preSubmit: u,
  handleBadRequest: p,
  hasErrors: d
}) {
  const { locale: y } = q(), { stripeBuyOffer: b } = x(), t = T(), r = j(), w = async (S) => {
    if (S.preventDefault(), !(!t || !r)) {
      o(!0);
      try {
        const e = u();
        if (!e) return;
        const { error: B } = await r.submit();
        if (B) return;
        const { redirect: n, intentSecret: i, intentType: _ } = await b(e, y);
        if (!i) return window.location.href = n;
        const g = _ === O.setup ? t.confirmSetup : t.confirmPayment, { error: m } = await g({
          elements: r,
          clientSecret: i,
          confirmParams: {
            payment_method_data: {
              billing_details: {
                name: [e.customer.fields.first_name, e.customer.fields.last_name].filter(Boolean).join(" "),
                email: e.customer.fields.email
              }
            },
            return_url: n
          }
        });
        m && l((s) => ({ ...s, common: [...s.common, m.message] }));
      } catch (e) {
        if (e instanceof E)
          p(e);
        else
          throw e;
      } finally {
        o(!1);
      }
    }
  };
  return /* @__PURE__ */ h(
    P,
    {
      disabled: f,
      className: D("main-transition-colors", d && "bg-danger focus:bg-danger"),
      onClick: w,
      isFetching: a,
      type: "submit",
      children: c
    }
  );
}
export {
  G as RedirectBasedPaymentButton
};
